import React, { SVGProps } from 'react';

const SvgCamera = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="123"
    height="80"
    viewBox="0 0 123 80"
    {...props}
  >
    <g
      fill="none"
      fillRule="evenodd"
    >
      <g stroke="#080808">
        <g transform="translate(-562 -1711) translate(563 1712)">
          <path d="M55.342.5h64.518c.415 0 .79.168 1.061.44.272.27.44.646.44 1.06h0v73.21c0 .414-.168.789-.44 1.06-.271.271-.646.44-1.06.44h0H2c-.414 0-.79-.169-1.06-.44-.272-.271-.44-.646-.44-1.06h0V8.955c0-.415.168-.79.44-1.061.27-.271.646-.44 1.06-.44h53.342V.5z"/>

          <path
            strokeLinecap="square"
            d="M36.744.465L36.744 4.186M33.023.465L33.023 4.186M40.465.465L40.465 4.186M44.186.465L44.186 4.186M47.907.465L47.907 4.186M51.628.465L51.628 4.186"
          />

          <path d="M7.012.5H29.268V4.151H7.012zM99.105 4.221H116.71000000000001V15.314H99.105zM75.849 5.151H90.66300000000001V14.384H75.849z"/>

          <path
            strokeLinecap="square"
            d="M79.535 7.907L79.535 11.628M83.256 7.907L83.256 11.628M103.721 30.233L103.721 33.953M86.977 7.907L86.977 11.628"
          />

          <circle
            cx="64.186"
            cy="47.442"
            r="29.267"
          />

          <circle
            cx="64.186"
            cy="47.442"
            r="24.616"
          />

          <path
            strokeLinecap="square"
            d="M.465 18.14L18.14 18.14M22.791 18.14L121.395 18.14"
          />

          <path d="M31.628 45.151c.89 0 1.695.36 2.277.944.583.582.944 1.388.944 2.277 0 .89-.36 1.695-.944 2.278-.582.583-1.388.943-2.277.943-.89 0-1.695-.36-2.278-.943s-.943-1.388-.943-2.278c0-.89.36-1.695.943-2.277.583-.583 1.388-.944 2.278-.944z"/>

          <circle
            cx="14.884"
            cy="61.395"
            r="7.872"
          />

          <path d="M21.826 15.384v4.558l.822 1.494c.266.484.335 1.028.228 1.535-.107.507-.391.977-.83 1.311-.464.353-1.017.53-1.57.53-.552 0-1.105-.177-1.569-.53-.439-.334-.723-.804-.83-1.312-.109-.507-.04-1.052.225-1.536h0l.803-1.462v-4.588h2.72zM105.76 28.436v6.572l1.117 2.094c.385.723.484 1.532.325 2.286-.16.755-.576 1.455-1.22 1.961-.66.518-1.455.777-2.25.777-.794 0-1.589-.259-2.249-.777-.645-.506-1.062-1.207-1.221-1.962-.16-.755-.062-1.564.323-2.288h0l1.09-2.048v-6.615h4.084z"/>

          <circle
            cx="14.884"
            cy="61.395"
            r="5.081"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgCamera;
